function handleSearchRekanan() {
    $("#search-input").on("keyup", function () {
        const value = $(this).val().toLowerCase();
        $("#list-rekanan .rekanan-item").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
          });
    });
}

module.exports = { handleSearchRekanan };
